import React, { FC } from "react";

export interface FailurePageContentProps {
  goBackUrl: string;
  goBackText: string;
}

export const FailurePageContent: FC<FailurePageContentProps> = ({
  goBackUrl,
  goBackText,
}) => (
  <div className="hero-image hero-image-city">
    <div className="l-wrapper clearfix">
      <div className="l-8-cols-tablet">
        <h1 className="color-error">Something went wrong!</h1>
        <p className="text-1">Please try to submit your form again.</p>
        <div className="l-push-top">
          <a className="button button-ghost-primary" href={goBackUrl}>
            {goBackText}
          </a>
        </div>
      </div>
    </div>
  </div>
);
